import Store from "$common/utils/store";
export default commomImport => [{
  path: `pre-order`,
  name: 'preOrder',
  meta: {
    title: ('store.preOrder'),
    nameCount: 'newOrder',
    noCache: true
  },
  //  全部订单
  component: commomImport('order-manager/pre-order')
}];
